export type ViewMode = "current" | "proposed";

export type MenuKey = "programs" | "brand" | "contact";

export const topNavItems: { label: string; hasMenu: boolean; menuKey?: MenuKey }[] = [
  { label: "Home", hasMenu: false },
  { label: "Programs", hasMenu: true, menuKey: "programs" },
  { label: "Coaches", hasMenu: true },
  { label: "Store", hasMenu: true },
  { label: "Blog", hasMenu: false },
  { label: "__brand__", hasMenu: true, menuKey: "brand" },
  { label: "Contact", hasMenu: true, menuKey: "contact" },
];

/** Sports as listed today under Programs → Find Programs (column order matches the live site). */
export const programSports = [
  "Flag Football",
  "Soccer",
  "Basketball",
  "Volleyball",
  "Athlete Development",
  "Tennis",
  "Baseball",
  "Lacrosse",
  "Cheerleading",
  "Multi Sport",
  "Nike Kids Camp",
  "Track & Field",
  "Girls",
];

export const currentContactColumns = [
  ["Frequently Asked Questions", "Employment Opportunities", "Media Inquiries", "Partners / Sponsors", "Franchise Opportunities"],
  ["Local Office", "Weather Hotline", "My Coaches"],
];

export const proposedContactGroups = [
  {
    heading: "For Families",
    items: ["Frequently Asked Questions", "Local Office", "Weather Hotline", "My Coaches"],
  },
  {
    heading: "Work With Us",
    items: ["Employment Opportunities", "Media Inquiries", "Partners / Sponsors", "Franchise Opportunities"],
  },
];

export const whyGroups = [
  {
    heading: "Who We Are",
    items: [
      { label: "Our Mission", description: "Helping kids succeed in life through sports" },
      { label: "The i9 Sports® Experience", description: "What a season looks like for your family" },
      { label: "How We're Different", description: "No tryouts, no drafts — everyone plays" },
    ],
  },
  {
    heading: "What We Stand For",
    items: [
      { label: "Sportsmanship Values", description: "A new value taught and recognized every week" },
      { label: "Parental Pledge", description: "Our shared promise for positive sidelines" },
      { label: "Gains for the Girls", description: "Building confidence for girls through sport" },
    ],
  },
];

export const proofPoints = [
  { value: "5M+", label: "Registrations nationwide" },
  { value: "Project Play", label: "Aspen Institute Champion" },
  { value: "Everyone plays", label: "Every child, every game" },
];

export type CompanyStatus = "keep" | "renamed" | "moved";

export const currentCompanyLinks: { label: string; status: CompanyStatus; note?: string }[] = [
  { label: "About i9 Sports®", status: "renamed", note: "Becomes Our Mission" },
  { label: "The i9 Sports® Experience", status: "keep" },
  { label: "How We're Different", status: "keep" },
  { label: "Sportsmanship Values", status: "keep" },
  { label: "Parental Pledge", status: "keep" },
  { label: "Sports We Play", status: "moved", note: "To Programs" },
  { label: "Frequently Asked Questions", status: "moved", note: "To Contact" },
  { label: "Gains are for the Girls", status: "keep" },
];

export const currentSports = [
  "Flag Football",
  "Soccer",
  "Baseball",
  "Basketball",
  "Lacrosse",
  "Volleyball",
  "Tennis",
  "Cheerleading",
  "Nike Kids Camp",
];

export const currentAgeGroups = [
  { code: "PW", label: "Pee Wees", color: "#e5302a" },
  { code: "J", label: "Juniors", color: "#1f1d5c" },
  { code: "S", label: "Seniors", color: "#5b6170" },
  { code: "G", label: "Girls", color: "#9b3fd6" },
];

export const movedItems = [
  { item: "Sports We Play", detail: "9 sports, incl. Nike Kids Camp", destination: "Programs", path: "Already listed under Find Programs — duplicate removed" },
  { item: "Age groups", detail: "Pee Wees, Juniors, Seniors, Girls", destination: "Programs", path: "New “By Age Group” column" },
  { item: "Frequently Asked Questions", detail: "Parent and registration help", destination: "Contact", path: "Already listed under Contact — duplicate removed" },
  { item: "Find a Program search", detail: "ZIP code lookup", destination: "Programs + top bar", path: "Already in both places" },
];

export const mobileSections: { label: string; children?: string[] }[] = [
  { label: "Home" },
  { label: "Programs", children: ["Find Programs by Sport", "By Age Group", "Find a Program Near You", "Browse All Programs"] },
  { label: "Coaches", children: ["Become a Coach", "Volunteer Application", "Coaching Resources"] },
  { label: "Store", children: ["Uniform Bottoms", "Shop by Sport", "Clearance"] },
  { label: "Blog" },
  { label: "__brand__" },
  { label: "Contact", children: ["Frequently Asked Questions", "Local Office", "Weather Hotline", "My Coaches", "Employment Opportunities", "Franchise Opportunities"] },
];
